module.exports = __webpack_public_path__ + "static/media/doutora.c001d6b5.jpg";